<script>
  import { Icon, Menu } from 'svelte-hero-icons';

  import Topbar from './topbar.svelte';
  import Navbar from './navbar.svelte';
  import MobileMenu from './mobile-menu.svelte';

  import Logo from '$lib/assets/images/logos/logo.svg';
  import menus from '$lib/utils/menus.js';

  let toggle = false;
  const props = {
    menus: menus,
    toggleClose: () => toggle = false,
  }

  let showTop = true;
  function onScroll() {
    const scrollTopVal =
    document.body.scrollTop || document.documentElement.scrollTop;
    // console.log(scrollTopVal);
    if (scrollTopVal > 117) {
      showTop = false;
    } else {
      showTop = true;
    }
  }
</script>

<header class="fixed w-full bg-white z-50">
  {#if showTop}
    <Topbar />
  {/if}
  <div class="ti-container">
    <div class="flex justify-between items-center py-4 md:space-x-8">
      <!-- Logo -->
      <div class="flex justify-start lg:w-0 lg:flex-1">
        <a href="/">
          <span class="sr-only">白溪基金</span>
          <img class="h-10 w-auto sm:h-12 lg:h-14" src={Logo} alt="Logo">
        </a>
      </div>

      <!-- Menu button -->
      <div class="-mr-2 -my-2 md:hidden">
        <button type="button" class="rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500" aria-expanded="false" on:click={() => toggle = true}>
          <span class="sr-only">打开菜单</span>
          <!-- Heroicon name: outline/menu -->
          <Icon src={Menu} class="h-6 w-6" />
        </button>
      </div>

      <!-- Menu -->
      <Navbar />
    </div>
  </div>

  <!-- Mobile menu -->
  <MobileMenu {toggle} {...props} />
</header>
<div class="h-32 border"></div>

<svelte:window on:scroll={onScroll} />
